import { parse, stringify } from 'query-string';
import { useHistory, useLocation } from 'react-router';
import isEmpty from 'lodash/isEmpty';

export enum ErrorType {
  invoice = 'invoice',
  apple_wallet_pass = 'apple_wallet_pass',
}

export const useErrorPresentInRedirect = () => {
  const params = parse(useLocation().search);
  const errorType = Array.isArray(params.error) ? params.error.shift() : params.error;
  const history = useHistory();

  if (isEmpty(params) || !errorType) {
    return;
  }

  delete params.error;
  history.replace({ search: stringify(params) });

  return ErrorType[errorType as ErrorType];
};
